export enum IPartnerFormFields {
	formalName = 'formalName',
	shortName = 'shortName',
	website = 'website',
	logo = 'logo',
	primaryColor = 'primaryColor',
	useOptionalHeaderLogo = 'useOptionalHeaderLogo',
	optionalHeaderLogo = 'optionalHeaderLogo',
	organizationIsicCode = 'organizationIsicCode',
	comment = 'comment',
	contractStartDate = 'contractStartDate',
	contractEndDate = 'contractEndDate',
	integrationId = 'integrationId',
	contract = 'contract',
	adminCountLimit = 'adminCountLimit',
	partnerUserCountLimit = 'partnerUserCountLimit',
	clientCountLimit = 'clientCountLimit',
	surveyCountLimit = 'surveyCountLimit',
	surveyLimitPerClientDtos = 'surveyLimitPerClientDtos',
}
